
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/install-success",
      function () {
        return require("private-next-pages/install-success.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/install-success"])
      });
    }
  